import React, { useEffect } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";

function About() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="about py-5 border-bottom" id="about">
      <div className="container-lg">
        <div className="about__headings my-4 fs-5">
          <span
            className="about__headings--small text-uppercase"
            data-aos={"fade-out"}
            data-aos-offset={10}
          >
            _About
          </span>
          <h1
            className="about__headings--h1 mt-3"
            data-aos={"fade-out"}
            data-aos-duration={1000}
            data-aos-offset={10}
          >
            About Me
          </h1>
        </div>
        <div className="row g-md-5 g-0">
          <div className="col-md-4 order-md-first order-second px-md-4">
            <div
              className="about__skills py-5 px-md-4 px-2 h-100 text-center"
              data-aos={"fade-right"}
              data-aos-offset={10}
              data-aos-duration={1100}
            >
              <h1 className="about__skills__heading py-2 px-4">Skills</h1>

              <div className="about__skills__range mt-5">
                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>HTML</span>
                  <span>100%</span>
                </label>
                <div className="about__skills__range__container border">
                  <div className="about__skills__range__container__skills html py-1"></div>
                </div>

                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>CSS/SASS</span>
                  <span>95%</span>
                </label>
                <div className="about__skills__range__container">
                  <div className="about__skills__range__container__skills css py-1"></div>
                </div>

                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>Javascript</span>
                  <span>85%</span>
                </label>
                <div className="about__skills__range__container">
                  <div className="about__skills__range__container__skills js py-1"></div>
                </div>

                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>Bootstrap/Tailwind</span>
                  <span>90%</span>
                </label>
                <div className="about__skills__range__container">
                  <div className="about__skills__range__container__skills bootstrap py-1"></div>
                </div>

                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>React js</span>
                  <span>85%</span>
                </label>
                <div className="about__skills__range__container">
                  <div className="about__skills__range__container__skills react py-1"></div>
                </div>

                <label className="about__skills__range__label d-flex justify-content-between mt-4">
                  <span>Next js</span>
                  <span>80%</span>
                </label>
                <div className="about__skills__range__container">
                  <div className="about__skills__range__container__skills next py-1"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8 col-11 py-1 py-0 order-md-second order-first">
            <div className="about__info border-bottom ">
              <h1
                className="about__info--h1 mb-3"
                data-aos={"fade-right"}
                data-aos-offset={50}
                data-aos-duration={1100}
              >
                I'm Ashir
              </h1>
              <h5
                className="about__info--h5 mt-2 mb-4"
                data-aos={"fade-right"}
                data-aos-offset={50}
                data-aos-duration={1100}
              >
                A Lead{" "}
                <span className="about__info--h5--color">Web Developer</span>{" "}
                based in{" "}
                <span className="about__info--h5--color">Pakistan</span>
              </h5>
              <p
                className="about__info__intro"
                data-aos={"fade-right"}
                data-aos-offset={50}
                data-aos-duration={1100}
              >
                I specialize in delivering top-notch design and development
                services to customers, with a focus on crafting stylish and
                contemporary websites, web services, and e-commerce platforms.
                My drive is to create engaging digital experiences through
                meaningful user interactions and design.
              </p>
            </div>
            <div className="about__personal py-3">
              <h1
                className="about__personal__heading text-uppercase"
                data-aos={"fade-right"}
                data-aos-offset={50}
                data-aos-duration={1100}
              >
                Personal Info
              </h1>
              <div
                className="about__personal__ccontainer d-md-flex d-block"
                data-aos={"fade-right"}
                data-aos-offset={50}
                data-aos-duration={1100}
              >
                <div className="about__personal__container about__personal__container__left">
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      Name:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      Ashir
                    </span>
                  </div>
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      Age:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      21 years
                    </span>
                  </div>
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      nationality:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      pakistan
                    </span>
                  </div>
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      Freelance:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      Available
                    </span>
                  </div>
                </div>

                <div className="about__personal__container about__personal__container__right">
                  <div className="about__personal__container____item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      Address:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      Sehgal city, Fsd
                    </span>
                  </div>
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      Email:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-break">
                      muhammadashirone@gmail.com
                    </span>
                  </div>
                  <div className="about__personal__container__item py-1">
                    <span className="about__personal__container__item--label pe-2 text-capitalize">
                      languages:{" "}
                    </span>
                    <span className="about__personal__container__item--value text-capitalize">
                      English, Urdu
                    </span>
                  </div>
                </div>
              </div>

              {/* <div
                className="about__personal__bottom"
                data-aos={"fade-right"}
                data-aos-offset={10}
              >
                <a
                  href="../../images/CV.pdf"
                  className="about__personal__bottom__button px-4 py-2 d-inline-block mt-3 text-decoration-none"
                  download="CV"
                >
                  Download CV
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
